import type { OfferLocaleOverrides } from '../base';

export const OHOverrides: OfferLocaleOverrides = {
  locale: 'OH',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
          },
        },
      },
    },
    buySideContacts: {
      cards: {
        buyersAgentCard: {
          disallowRemoveForIndex: () => [],
        },
        buyerCard: {
          disallowRemoveForIndex: [0],
        },
      },
    },
  },
};
